var parser = {
  // 以下由 bowser 插件返回默认结构
  browser: undefined,
  // cpu: parser.parsedResult.,
  device: {},
  engine: undefined,
  os: {},
  text: '',
};
let userAgent = '';

if (typeof window !== 'undefined') {
  parser = window.moo.ua;
  userAgent = parser.text;
}
const IS_TABLET = parser.device.type === 'tablet'; // 平板电脑
const IS_MOBILE = IS_TABLET || parser.device.type === 'mobile'; // 移动设备

// 安卓 parser.os.name
const IS_HARMONY = /^(HarmonyOS)$/.test(userAgent); // 会判断鸿蒙成 HarmonyOS ，而不是安卓，但实际工作中 HarmonyOS 就是安卓来判断

const IS_ANDROID =
  /^(Android)$/.test(userAgent) ||
  IS_HARMONY ||
  new RegExp('Android').test(userAgent) ||
  new RegExp('Android'.toLowerCase()).test(userAgent);

// iOS
const IS_MAC = /Macintosh|MacIntel|MacPPC|Mac OS|MacOS|Mac68K/.test(userAgent);
const IS_IOS =
  /^(iOS)$/.test(userAgent) ||
  new RegExp('iPad').test(userAgent) ||
  new RegExp('iPad'.toLowerCase()).test(userAgent) ||
  new RegExp('iPhone').test(userAgent) ||
  new RegExp('iPhone'.toLowerCase()).test(userAgent) ||
  new RegExp('iPod').test(userAgent) ||
  new RegExp('iPod'.toLowerCase()).test(userAgent) ||
  IS_MAC ||
  new RegExp('iOS').test(userAgent) ||
  new RegExp('iOS'.toLowerCase()).test(userAgent);

// PC
const IS_WINDOWS =
  /^(Windows)$/.test(parser.os.name) ||
  new RegExp('Windows').test(userAgent) ||
  new RegExp('Windows'.toLowerCase()).test(userAgent);

// TapTap
export function getIsInTapTap() {
  return !!(
    typeof window !== 'undefined' &&
    (window.TapTapAPI || (window.urlResource && window.urlResource.TapTapAPI))
  );
}
const IS_IN_TAPTAP = getIsInTapTap();

//腾讯
const IS_BROWSER_QQ = /^QQ(Browser|BrowserLiteLite)?$/.test(userAgent);
const IS_WECHAT = /^WeChat$/.test(userAgent);

const isCrawler = (userAgent) => {
  const crawlerKeywords = [
    'Googlebot',
    'Bingbot',
    'Slurp',
    'DuckDuckBot',
    'Baiduspider',
    'YandexBot',
    'Sogou',
    'Exabot',
    'AdsBot',
    'facebookexternalhit',
    'ia_archiver',
  ];
  return crawlerKeywords.some((keyword) => (userAgent || '').includes(keyword));
};

const IS_CRAWLER = isCrawler(parser.text);

export default {
  IS_MOBILE,
  IS_TABLET,
  IS_HARMONY,
  IS_ANDROID,
  IS_IOS,
  IS_WINDOWS,
  IS_IN_TAPTAP,
  IS_BROWSER_QQ,
  IS_WECHAT,
  IS_CRAWLER,
  getIsInTapTap,
};
